export default {
  isLoggedIn: false,
  showLoader: false,
  authToken: '',
  userDetails: {},
  showDialog: false,
  deletePayload: {},
  supportList: {},
  filterByActiveUser: 0,
  isChangesMade: false,
  changeLostDialog: false,
  changeSaveUpdateDialog: false,
  isLocalDelete: false,
  dialogOkCb: () => { },
  dialogCancelCb: () => { },
  FORM_TYPE: {
    TEXT: 'text',
    TEXTAREA: 'textarea',
    CHECKBOX: 'checkbox',
    SELECT: 'select',
    AUTO_COMPLETE: 'auto_complete',
    AUTO_COMPLETE_LIVE: 'auto_complete_live',
    COMBOBOX: 'combobox',
    DATE: 'date',
    PASSWORD: 'password',
    NUMBER: 'number',
    DATEPICKER: 'datepicker',
    QUICKADD: 'quickadd',
    TIMEPICKER: 'timepicker',
    FILES: 'files',
    ALERT: 'alert',
    COLORPICKER: 'color',
    BUTTON: 'btn',
    BTNDROPDOWN: 'btnDropdown',
    RADIO: 'radio',
    DIVIDER: 'divider',
    LINK: 'link',
    LABEL: 'label',
    SLOT: 'slot'
  },
  listOfUnits: [],
  listOfUsers: [],
  listOfMailboxes: [],
  listOfUserGroupMailboxes: [], // user's group's mailbox list
  listOfTypes: [],
  listOfTicketPriorities: [],
  listOfTicketStatus: [],
  listOfUserRoles: [],
  listOfGroups: [],
  listOfProductGroups: [],
  listOfDevationCategory: [],
  listOfDevationMeasureCategory: [],
  listOfDevationMeasureStatus: [],
  listOfDevationStatus: [],
  listOfDevationLocation: [],
  listOfCustomerPriorities: [],
  listofCustomerIndustries: [],
  listofCustomerShipments: [],
  listOfSalesAccounts: [],
  listOfSuppliers: [],
  listOfCurrency: [],
  listOfWarehouse: [],
  listOfLocations: [],
  listOfCustomers: [],
  listOfTicketCategories: [],
  listOfPaymentTerms: [],
  listOfDeliveryTerms: [],
  listOfModules: [],
  // LIST ITEMS
  CRM_INDEX: {},
  USER_INDEX: {},
  USERROLE_INDEX: {},
  PRODUCTGROUP_INDEX: {},
  PRIORITIES_INDEX: {},
  TICKETSTATUS_INDEX: {},
  TICKETCATEGORY_INDEX: {},
  TICKETTYPE_INDEX: {},
  PRODUCT_UNIT_INDEX: {},
  GROUP_INDEX: {},
  TICKETS_INDEX: {},
  MAIL_CONFIG_INDEX: {},
  PRODUCT_INDEX: {},
  ORDER_INDEX: {},
  ORDER_LINE_INDEX: {},
  DEVIATION_INDEX: {},
  DEVIATION_CATEGORY_INDEX: {},
  DEVIATION_MEASURE_CATEGORY_INDEX: {},
  DEVIATION_MEASURE_INDEX: {},
  DEVIATION_STATUS_INDEX: {},
  DEVIATION_LOCATION_INDEX: {},
  MEASURE_STATUS_INDEX: {},
  PAYMENT_TERM_INDEX: {},
  DELIVERY_TERM_INDEX: {},
  F_TICKETS: {},
  F_CUSTOMERS: {},
  F_ALL_TICKETS: {},
  F_OPEN_TICKETS: {},
  F_UNASSIGNED_TICKETS: {},
  F_MY_ACTIVE: {},
  F_CLOSED: {},
  F_ACCOUNT_TICKETS: {},
  F_ORDERS: {},
  F_WAREHOUSE: {},
  F_PRODUCT: {},
  F_INVOICE: {},
  F_DEVIATION: {},
  F_GROSS_MARGIN: {},
  CUSTOMER_SHIPMENT_INDEX: {},
  CUSTOMER_PRIORITIES_INDEX: {},
  CUSTOMER_INDUSTRIES_INDEX: {},
  CURRENCY_INDEX: {},
  CURRENCY_ACTION_INDEX: {},
  SALES_ACCOUNTS_INDEX: {},
  WAREHOUSE_SETTINGS: {},
  WAREHOUSE_LOCATION: {},
  STOCK_INDEX: {},
  WH_ORDER_INDEX: {},
  F_WH_ORDERS: {},
  CCSHEET_INDEX: {},
  GROSS_MARGIN_INDEX: {},
  INVOICE_INDEX: {},
  BATCHES_INDEX: {},
  PRICE_HISTORY_INDEX: {},
  F_HSE_LIST: {},
  F_WH_CCSHEET_ITEM_LIST: {},
  F_WH_PRODUCT_BATCHES: {},
  F_ORDER_INVOICE: {},
  MAILADDRESSFILTER_INDEX: {},
  PROPS_INDEX: {},
  FORM_PROPS_INDEX: {},
  ORDER_CHECKLIST_INDEX: {},
  TEMPLATE_INDEX: {},
  DOCUMENT_BUILDER_INDEX: {}
}
